import { get } from 'lodash';

export const getProductLicenses = (state) => {
  const ret = get(state, 'CommonState.products.data', []);
  return ret || [];
};

export const getIsProductLicensed = (state, product) => {
  const licenses = getProductLicenses(state);
  const ret = licenses.some((x) => x === product);
  return ret;
};

export const getProductLicensesFetching = (state) =>
  get(state, 'CommonState.products.fetching');



// WEBPACK FOOTER //
// ./src/state/product/selectors.js